import { useTranslation } from 'react-i18next'
import CallToAction from 'app/frontend/base/components/CallToAction'
import { useGameVersion } from 'app/frontend/base/hooks/useGameVersion'

interface Props {
  context: 'guild' | 'character'
  dismissible?: boolean
}

const CompanionCta = ({ context, dismissible }: Props) => {
  const { t } = useTranslation()
  const gameVersion = useGameVersion()

  if (gameVersion.has('blizzard_api')) return null

  const character = context === 'character'

  return (
    <CallToAction
      title={t(
        character
          ? 'manual-sync.character-cta.title'
          : 'manual-sync.companion-cta.title',
      )}
      uid={
        character
          ? `wowaudit-companion-character-${gameVersion.id}`
          : `wowaudit-companion-${gameVersion.id}`
      }
      dismissible={dismissible ?? !character}
      actions={[
        {
          label: t('manual-sync.companion-cta.curseforge'),
          href: 'https://www.curseforge.com/wow/addons/wowaudit-companion',
        },
        {
          label: t('manual-sync.companion-cta.wago'),
          href: 'https://addons.wago.io/addons/wowaudit-companion',
        },
        {
          label: t('manual-sync.companion-cta.desktop'),
          href: '/desktop',
        },
      ]}
    >
      {t(
        character
          ? 'manual-sync.character-cta.description'
          : 'manual-sync.companion-cta.description',
      )}
    </CallToAction>
  )
}

export default CompanionCta
